<template>
  <div>
    <div class="main-container">
      <div
        style="
          position: fixed;
          top: 20px;
          z-index: 1;
          backdrop-filter: blur(2px);
        "
        v-if="LoaderStatus"
      >
        <Spinner />
      </div>
      <div
        class="page-heading d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center pointer" @click="gotoback()">
          <img src="../../assets/bckarrow.svg" alt="" />
          <div class="main-head ml-4">
            <span>Generate offer letter</span>
          </div>
        </div>
      </div>
      <div class="offerletter-container mt-3 relativeclass">
        <div class="templatecards-heading p-0">Confirm candidate details</div>
        <b-row class="mt-3">
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle"
                >First Name&nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                id="input-1"
                type="text"
                placeholder="Enter first name"
                v-model.trim="$v.offerletter.firstName.$model"
                :class="{ error: $v.offerletter.firstName.$error }"
              >
              </b-form-input>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.firstName.$dirty &&
                  !$v.offerletter.firstName.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle"
                >Middle Name &nbsp;<span class="asterik"></span
              ></label>
              <b-form-input
                class="inputField input-data"
                id="input-1"
                placeholder="Enter middle name"
                type="text"
                v-model="offerletter.middleName"
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle"
                >Last Name&nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                id="input-1"
                placeholder="Enter last name"
                type="text"
                v-model.trim="$v.offerletter.lastName.$model"
                :class="{ error: $v.offerletter.lastName.$error }"
              >
              </b-form-input>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.lastName.$dirty &&
                  !$v.offerletter.lastName.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle"
                >Experience &nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                id="input-1"
                type="text"
                placeholder="Enter experience"
                v-model="$v.offerletter.experince.$model"
                :class="{ error: $v.offerletter.experince.$error }"
              >
              </b-form-input>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.experince.$dirty &&
                  !$v.offerletter.experince.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <div class="topDiv">
              <label class="disabledfieldsetStyle">Email ID</label>
              <b-form-input
                class="dateFieldStyle"
                id="input-1"
                placeholder="Enter email"
                type="text"
                disabled
                v-model="offerletter.email"
              >
              </b-form-input>
            </div>
          </b-col>

          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle"
                >Contact Number&nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                id="input-1"
                type="text"
                placeholder="Enter number"
                v-model.trim="$v.offerletter.phoneNumber.$model"
                :class="{ error: $v.offerletter.phoneNumber.$error }"
                maxLength="10"
              >
              </b-form-input>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.phoneNumber.$dirty &&
                  !$v.offerletter.phoneNumber.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
              <div
                class="validationicon"
                v-if="
                  !$v.offerletter.phoneNumber.alpha &&
                  $v.offerletter.phoneNumber.required
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Invalid Contact number',
                }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>

              <div
                class="validationicon"
                v-if="
                  !$v.offerletter.phoneNumber.minLength &&
                  !$v.offerletter.phoneNumber.maxLength &&
                  $v.offerletter.phoneNumber.required
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Should contain 10 digits',
                }"
                variant="primary"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle"
                >Alternate Contact Number&nbsp;<span class="asterik"></span
              ></label>
              <b-form-input
                class="inputField input-data"
                id="input-1"
                placeholder="Enter number"
                type="text"
                v-model="offerletter.altPhoneNumber"
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="datefieldsetStyle"
                >D.O.B&nbsp;<span class="asterik">*</span></label
              >
              <b-form-datepicker
                ref="dob"
                class="pointer joiningstyle"
                v-model="$v.offerletter.dateOfBirth.$model"
                :max="dateDisabled"
                :class="{ error: $v.offerletter.dateOfBirth.$error }"
              ></b-form-datepicker>
              <div
                class="offer-dates-validationicon"
                v-if="
                  $v.offerletter.dateOfBirth.$dirty &&
                  !$v.offerletter.dateOfBirth.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>

              <img
                @click="gotodob"
                class="calender-class pointer"
                src="../../assets/calenderIcon.svg"
                alt=""
              />
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <div class="topDiv datepicker-cust">
              <label class="datefieldsetStyle"
                >Date of Joining&nbsp;<span class="asterik">*</span></label
              >
              <b-form-datepicker
                ref="doj"
                :min="dateDisabled"
                id="example-datepicker3"
                class="joiningstyle pointer input-data"
                v-model="$v.offerletter.dateOfJoining.$model"
                :class="{ error: $v.offerletter.dateOfJoining.$error }"
              ></b-form-datepicker>
              <div
                class="offer-dates-validationicon"
                v-if="
                  $v.offerletter.dateOfJoining.$dirty &&
                  !$v.offerletter.dateOfJoining.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
              <img
                @click="gotodoj"
                class="calender-class pointer"
                src="../../assets/calenderIcon.svg"
                alt=""
              />
            </div>
          </b-col>

          <b-col>
            <div class="topDiv">
              <label class="disabledfieldsetStyle">Expected CTC</label>
              <b-form-input
                class="dateFieldStyle"
                id="input-1"
                type="text"
                disabled
                :placeholder="`${offerletter.expectedCTC * 100000}`"
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="disabledfieldsetStyle">Current CTC</label>
              <b-form-input
                class="dateFieldStyle"
                id="input-1"
                type="text"
                disabled
                :placeholder="`${offerletter.currentCTC * 100000}`"
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle" style="z-index: 0"
                >Offered CTC&nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                id="input-1"
                type="text"
                placeholder="Enter offered CTC"
                v-model.trim="$v.offerletter.offeredCTC.$model"
                :class="{ error: $v.offerletter.offeredCTC.$error }"
              >
              </b-form-input>
              <div
                class="mr-2 validationicon"
                v-if="
                  $v.offerletter.offeredCTC.$dirty &&
                  !$v.offerletter.offeredCTC.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
              <div
                class="validationicon"
                v-if="
                  !$v.offerletter.offeredCTC.numeric &&
                  $v.offerletter.offeredCTC.required
                "
                v-b-popover.hover.top.v-danger="{
                  content: 'Invalid CTC',
                }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle" style="z-index: 0"
                >Employer Address&nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                id="input-1"
                type="text"
                placeholder="Enter address"
                v-model.trim="$v.offerletter.currentLocation.$model"
                :class="{ error: $v.offerletter.currentLocation.$error }"
              >
              </b-form-input>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.currentLocation.$dirty &&
                  !$v.offerletter.currentLocation.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>

          <b-col>
            <div
              class="topDiv"
              ref="exp"
              @click="departmentfunction()"
              v-closable="{
                exclude: ['exp', 'expdropdown'],
                handler: 'hidedepartmentoptions',
              }"
            >
              <label class="fieldsetStyle" style="z-index: 0"
                >Department&nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                type="text"
                v-model="$v.offerletter.department.$model"
                :class="{ error: $v.offerletter.department.$error }"
                placeholder="Enter or Select Department"
              ></b-form-input>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.department.$dirty &&
                  !$v.offerletter.department.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
              <div
                v-if="deptopt == true"
                class="offerletter-department-modal"
                ref="expdropdown"
              >
                <div
                  v-for="i in Departments"
                  :key="i.code"
                  class="pointer dept-name"
                  @click="selectDept(i.name)"
                  :class="
                    offerletter.department == i.name
                      ? 'rejectedsched-roundbox-bluebox'
                      : 'qb-dropdown-option-sing'
                  "
                >
                  {{ i.name }}
                </div>
              </div>
            </div>
          </b-col>

          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle"
                >Designation&nbsp;<span class="asterik">*</span></label
              >
              <b-form-select
                class="inputField"
                type="text"
                v-model="$v.offerletter.designation.$model"
                :options="Designations"
                :class="{ error: $v.offerletter.designation.$error }"
              ></b-form-select>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.designation.$dirty &&
                  !$v.offerletter.designation.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle" style="z-index: 0"
                >Job Type&nbsp;<span class="asterik">*</span></label
              >
              <b-form-select
                class="inputField input-data"
                type="text"
                v-model="$v.offerletter.jobType.$model"
                :class="{ error: $v.offerletter.jobType.$error }"
                :options="JobTypeoptions"
              ></b-form-select>
              <div
                class="validationicon"
                v-if="
                  $v.offerletter.jobType.$dirty &&
                  !$v.offerletter.jobType.required
                "
                v-b-popover.hover.top.v-danger="{ content: 'Required' }"
              >
                <img src="../../assets/deletepopupicon.svg" alt="" />
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="3">
            <div class="topDiv">
              <label class="disabledfieldsetStyle">Notice Period</label>
              <b-form-input
                class="dateFieldStyle"
                disabled
                id="input-1"
                type="text"
                v-model="offerletter.noticePeriod"
              >
              </b-form-input>
            </div>
          </b-col>

          <b-col cols="3">
            <div class="topDiv">
              <label class="fieldsetStyle"
                >Gender&nbsp;<span class="asterik">*</span></label
              >
              <b-form-input
                class="inputField input-data"
                id="input-1"
                type="text"
                v-model="offerletter.gender"
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="topDiv">
              <label class="disabledfieldsetStyle"
                >Highest Qualification&nbsp;
              </label>
              <b-form-input
                class="dateFieldStyle"
                disabled
                id="input-1"
                type="text"
                v-model="offerletter.highestQualification"
              >
              </b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle" style="z-index: 0"
                >Job Description&nbsp;<span class="asterik"></span
              ></label>
              <b-form-textarea
                class="inputField"
                id="input-1"
                type="text"
                placeholder="Enter description"
                rows="4"
                max-rows="7"
                v-model="offerletter.jobDescription"
              >
              </b-form-textarea>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <div class="topDiv ml-2">
              <b-form-checkbox
                class="templatecards-heading mt-3"
                v-model="isAddNotesChecked"
              >
                Add additional instructions
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3" v-if="isAddNotesChecked">
          <b-col>
            <div class="topDiv">
              <label class="fieldsetStyle" style="z-index: 0"
                >Notes&nbsp;<span class="asterik"></span
              ></label>
              <QuillEditor
                :addquesProp="addques1"
                :value="testConfigData.config.testDesc"
                :disableQuill="true"
                @validationVal="validateText"
                @questionText="updateQuestionContent"
                @addquesBack="changedaddQues"
              >
              </QuillEditor>
            </div>
            <div
              class="validationicon-note"
              v-if="$v.offerletter.note.$dirty && !$v.offerletter.note.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
            <div
              class="validationicon-note"
              v-if="
                !$v.offerletter.note.maxLength && $v.offerletter.note.required
              "
              v-b-popover.hover.top.v-danger="{
                content: 'Should not exceed 1024 characters',
              }"
              variant="primary"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
          </b-col>
        </b-row>

        <div
          class="d-flex align-items-center pointer justify-content-end"
          style="position: absolute; right: 16px; bottom: 19px"
        >
          <div class="mr-4 cancelbtntext" @click="gotoback()">Cancel</div>
          <b-button class="addbtn pl-4 pr-4" @click="offerletterdetails">
            Next
          </b-button>
        </div>
      </div>
    </div>

    <b-modal
      id="viewmore"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="md"
    >
      <div class="xMarkCancel">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <b-row>
        <b-col cols="3">
          <div class="candres-status-text text-center">Status &emsp;:</div>
        </b-col>
        <b-col> <div class="candres-progress">Rejected</div></b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <div class="candres-status-text text-center">Remarks :</div>
        </b-col>
        <b-col>
          <div class="candres-remark-des">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi
            modi blanditiis delectus quam dolore velit beatae accusamus
            quisquam, similique ab, illum, quas qui obcaecati dolorum soluta!
            Illum excepturi at reiciendis.
          </div></b-col
        >
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import QuillEditor from "../../components/fixedcomponents/quillEditor.vue";

import {
  getselectedcand,
  addofferletter,
  putofferletter,
} from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import offerLetterMixin from "../../controllers/HR/offerletterMixin";
export default {
  name: "offerletter",
  mixins: [toast, offerLetterMixin],

  components: {
    Spinner,
    QuillEditor,
  },

  methods: {
    selectDept(name) {
      this.offerletter.department = name;
      this.deptopt = false;
    },
    async offerletterdetails() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          if (!this.isAddNotesChecked) {
            this.offerletter.note = "";
          }
          if (Object.keys(this.selectCandidate).length == 0) {
            const res = await addofferletter(this.offerletter);
            if (res.status == 200) {
              this.$store.commit(
                "hrPortalReferenceVUEX/saveSelectCandidate",
                this.offerletter
              );
            }
          } else {
            const res = await putofferletter(this.offerletter);
            if (res.status == 200) {
              this.$store.commit(
                "hrPortalReferenceVUEX/saveSelectCandidate",
                this.offerletter
              );
            }
          }
          this.$router.push({
            name: "TemplatesOfferLetter",
            query: {
              redirect: "OfferLetter",
              to: this.$route.query.redirect,
            },
          });
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    getOfferDetails() {
      this.LoaderStatus = true;
      if (Object.keys(this.selectCandidate).length == 0) {
        getselectedcand(this.$route.params.candidateID)
          .then((res) => {
            if (res.status == 200) {
              this.LoaderStatus = false;
              this.offerletter.firstName = res.data.data.name;
              this.offerletter.currentLocation = res.data.data.currentLocation;
              this.offerletter.email = res.data.data.email;
              this.offerletter.candidateID = res.data.data.candidateID;
              this.offerletter.currentCTC = res.data.data.currentCTC;
              this.offerletter.expectedCTC = res.data.data.expectedCTC;
              this.offerletter.gender = res.data.data.gender;
              this.offerletter.highestQualification =
                res.data.data.highestQualification;

              this.offerletter.phoneNumber = res.data.data.phoneNumber;

              this.offerletter.noticePeriod = res.data.data.noticePeriod;
              this.offerletter.experince = res.data.data.experince;
              this.offerletter.department = "";
              this.offerletter.altPhoneNumber = "";
            }
          })

          .catch((err) => {
            throw err;
          });
      } else {
        this.offerletter = this.selectCandidate;
        this.LoaderStatus = false;
      }
      if (
        this.offerletter.note == null ||
        this.offerletter.note.length == 0 ||
        this.offerletter.note == ""
      ) {
        this.isAddNotesChecked = false;
      } else {
        this.isAddNotesChecked = true;
      }
    },
  },
};
</script>

<style>
.b-form-btn-label-control.form-control > .btn > svg {
  display: none !important;
}
.input-data {
  color: #696969;
}
.offer-dates-validationicon {
  position: absolute;
  top: 5px;
  right: 30px;
  background: var(--bg-white);
}
.dateFieldStyle {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  background: #fdfdfd;
  box-shadow: 0px 0px 15px rgb(0 0 0 / 10%);
  border-radius: 3px !important;
}
.disabledfieldsetStyle {
  color: var(--bg-tertiary);
  background-color: #ebebeb;
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-size: var(--size-10);
  line-height: 18px;
  z-index: 0;
  padding-left: 6px;
  padding-right: 4px;
}

.datepicker-cust .btn {
  padding: 0.375rem 0;
}
.calender-class {
  position: absolute;
  top: 7px;
  right: 10px;
  z-index: 1;
}

.candres-viewmore {
  font-weight: 500;
  font-size: 12px;

  text-decoration-line: underline;

  color: rgba(114, 115, 142, 0.7);
}
.candres-line {
  border: 1px solid #72738e;
  height: 45px;
  width: 1px;
}
.candres-remark-des {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}
.candres-progress {
  font-weight: 500;
  font-size: 14px;
  color: var(--cv-red);
}
.candres-status-text {
  font-weight: 400;
  font-size: 14px;
  color: #696969;
}
.candres-date {
  font-weight: 500;
  font-size: 10px;
  color: #696969;
}
.cand-res-head {
  font-weight: 600;
  font-size: 14px;
  color: #696969;
}
.candres-dp {
  height: 35px;
  width: 35px;
  border-radius: 20px;

  border: 1px solid blue;
}
.emailinputField {
  background: #f4f4f4;
  border: 1px solid rgba(10, 86, 200, 0.5);

  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;

  z-index: 5;
  padding-left: 6px;
}
.dept-name {
  font-size: 14px;
  font-weight: 400;
  color: #6d6d6d;
}
.offerletter-department-modal {
  padding: 10px;
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  z-index: 6;
  position: absolute;
  width: 100%;
}
.topDiv > .joiningstyle {
  border: 0.7px solid rgba(114, 115, 142, 0.7);
  box-shadow: 0px 0px 15px rgb(0 0 0 / 10%);
}
</style>
